import React from 'react';
import classNames from 'classnames';
import { SpinnerProps } from './interface';

import './_Spinner.scss';

const Spinner: React.FC<SpinnerProps> = ({ small, ...props }) => {
  const className: string = classNames('spinner', {
    'no-margin': small,
  });

  if (props.className) {
    return <div className={className + ' ' + props.className}></div>;
  }

  return <div className={className}></div>;
};

export default Spinner;
